import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/RegistroUsuario`

export function registrarUsuario(regData) {
  return http.post(`${API_ENDPOINT}/Registrar/`, regData)
}

export function verificar(idUsuario, codigoVerif) {
  return http.get(`${API_ENDPOINT}/Verificar/${idUsuario}/${codigoVerif}`)
}

export function validarCUIT(cuit) {
  return http.get(`${API_ENDPOINT}/ValidarCUIT/${cuit}`)
}
